import React, { useContext, useEffect, useState } from "react";

// import contect
import { Data } from "./../App";
import ControlBox from "./ControlBox";
import StudentsList from "./StudentsList";

const Students = () => {
  const students = useContext(Data);

  const [category, setCategory] = useState("all");
  const [all_students] = useState(students);

  /**************************** start cycle_students state ********************/
  const [cycle_students, setCycle_students] = useState([]);
  const [cycle_number, setCycle_number] = useState(1);

  useEffect(() => {
    setCycle_students(
      all_students.filter((element) => +element.cycle === +cycle_number)
    );
  }, [cycle_number, all_students]);
  /**************************** end cycle_students state ********************/

  /*********************  start department_list state ***********************/
  const [department_list, setDepartment_list] = useState([]);

  useEffect(() => {
    let depts = students
      .map((element) => {
        return element.department;
      })
      .filter((element) => element);

    setDepartment_list([...new Set(depts)]);
  }, [students]);
  /*********************  end department_list state ***********************/

  /********************** start dept_students state **********************/
  const [dept_students, setDept_students] = useState([]);
  const [dept_name, setDept_name] = useState("");

  useEffect(() => {
    setDept_name(department_list[0]);
  }, [department_list]);

  useEffect(() => {
    setDept_students(
      all_students.filter((element) => element.department === dept_name)
    );
  }, [dept_name, all_students]);
  /********************** end dept_students state **********************/

  // start students_to_render variable
  const students_to_render =
    category === "all"
      ? all_students
      : category === "cycle"
      ? cycle_students
      : dept_students;

  return (
    <div className="students">
      {/* start control box */}
      <ControlBox
        students={students}
        setCategory={setCategory}
        cycle_number={cycle_number}
        setCycle_number={setCycle_number}
        setDept_name={setDept_name}
        department_list={department_list}
      ></ControlBox>

      {/* start render students */}
      <StudentsList students_to_render={students_to_render}></StudentsList>
    </div>
  );
};

export default Students;
